import * as React from 'react';
import { AddButton } from 'ui';
import { MdAdd } from 'react-icons/md';
import { TileWrapper } from 'app/components/tile-wrapper/tile-wrapper';
import { TextsProps } from '../types';
import { TextsItem } from './texts-item';
import styles from './texts-container.scss';

export const TextsContainer = (props: TextsProps) => {
  const { companyReportItem: { texts } = {}, addText, translation } = props;

  return <TileWrapper>
    <div className={styles.container}>
      {texts.length > 0
        ? texts.map(item =>
          <TextsItem
            key={item.id}
            value={item}
            {...props} />)
        : <p className="no-content">{translation.texts_no_data}</p>}
      <AddButton icon={MdAdd} onClick={addText}>
        {translation.add_text}
      </AddButton>
    </div>
  </TileWrapper>;
};
